import React from "react";
import { Link } from "react-router-dom";
import { Edit } from "react-feather";
import { Button, Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";
import Table from "../../../core/pagination/datatable";
//import RefreshIcon from "../../../core/common/tooltip-content/refresh";
//import CollapesIcon from "../../../core/common/tooltip-content/collapes";
import CommonFooter from "../../../core/common/footer/commonFooter";
import SettingsSideBar from "../settingssidebar";
import StickyBar from "../../../core/common/StickyBar";
import {
  fetchPaymentMethods,
  openModal,
  closeModal,
  openDeleteModal,
  closeDeleteModal,
  removePaymentMethod,
  addPaymentMethod,
  editPaymentMethod,
} from "../../../core/redux/paymentMethod.slice";
import PaymentMethodFormModal from "./PaymentMethodFormModal";
import { useTranslation } from "react-i18next";
const PaymentMethods = () => {
  const dispatch = useDispatch();
  const { paymentMethods, showModal, showDeleteModal, loading } = useSelector(
    (s) => s.paymentMethod,
  );
  const { t } = useTranslation();
  const [selected, setSelected] = React.useState(null);
  const [toDelete, setToDelete] = React.useState(null);
  const [isEditMode, setIsEditMode] = React.useState(false);

  React.useEffect(() => {
    if (!paymentMethods.length) dispatch(fetchPaymentMethods());
  }, [dispatch, paymentMethods]);

  const onFinish = (values) => {
    if (isEditMode)
      dispatch(
        editPaymentMethod({
          id: selected.paymentMethodId,
          paymentMethod: values,
        }),
      );
    else dispatch(addPaymentMethod(values));
  };

  const columns = [
    { title: t("paymentMethods.name"), dataIndex: "paymentMethodName" },
    { title: t("paymentMethods.description"), dataIndex: "paymentMethodDescription" },
    {
      title: t("paymentMethods.status"),
      dataIndex: "paymentMethodIsActive",
      render: (isActive) => (
        <div>
          {isActive ? (
            <span className="d-inline-flex align-items-center p-1 pe-2 rounded-1 text-white bg-success fs-10">
              <i className="ti ti-point-filled me-1 fs-11"></i>  {t("paymentMethods.active")}
            </span>
          ) : (
            <span className="d-inline-flex align-items-center p-1 pe-2 rounded-1 text-white bg-danger fs-10">
              <i className="ti ti-point-filled me-1 fs-11"></i> {t("paymentMethods.inactive")}
            </span>
          )}
        </div>
      ),
    },

    {
      title: t("paymentMethods.actions"),
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              to="#"
              className="me-2 p-2"
              onClick={() => {
                setIsEditMode(true);
                setSelected(record);
                dispatch(openModal());
              }}
            >
              <Edit />
            </Link>
            <Link
              to="#"
              className="p-2 d-flex align-items-center border rounded"
              onClick={() => {
                setToDelete(record.paymentMethodId);
                dispatch(openDeleteModal());
              }}
            >
              <i data-feather="trash-2" className="feather-trash-2" />
            </Link>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content settings-content">
        <StickyBar
          title={t("paymentMethods.title")}
          count={paymentMethods.length}
          actions={
            <Button className="btn-customized-primary">
              <Link to="#" onClick={() => { setIsEditMode(false); dispatch(openModal()); }}>
                <i className="ti ti-circle-plus me-1" />  {t("paymentMethods.add")}
              </Link> </Button>} />

        <div className="row">
          <div className="col-xl-12">
            <div className="settings-wrapper d-flex">
              <SettingsSideBar />
              <div className="flex-fill w-50">
                {showModal ? (
                  <PaymentMethodFormModal
                    loading={loading}
                    initialData={isEditMode ? selected : {}}
                    isEdit={isEditMode}
                    onSubmit={onFinish}
                    onCancel={() => dispatch(closeModal())}
                  />
                ) : (
                  <div className="card table-list-card">
                    <div className="card-header d-flex justify-content-between">
                      <h4>{t("paymentMethods.title")}</h4>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <Table columns={columns} dataSource={paymentMethods} />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <CommonFooter />

      {/* <PaymentMethodFormModal
        loading={loading}
        initialData={isEditMode ? selected : {}}
        isEdit={isEditMode}
        open={showModal}
        onSubmit={onFinish}
        onCancel={() => dispatch(closeModal())}
      /> */}

      <Modal
        open={showDeleteModal}
        onCancel={() => dispatch(closeDeleteModal())}
        footer={null}
      >
        <div className="content p-5 text-center">
          <span className="rounded-circle d-inline-flex p-2 bg-danger-transparent mb-2">
            <i className="ti ti-trash fs-24 text-danger" />
          </span>
          <h4>{t("paymentMethods.confirmDeleteTitle")}</h4>
          <p>{t("paymentMethods.confirmDeleteText")}</p>
          <div className="d-flex justify-content-center gap-2">
            <Button onClick={() => dispatch(closeDeleteModal())}>
              {t("common.cancel")}
            </Button>
            <Button
              type="primary"
              loading={loading}
              onClick={() => dispatch(removePaymentMethod(toDelete))}
            >
              {t("common.confirmDelete")}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PaymentMethods;
